import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'TableRow',
    props: {
        selectable: { type: Boolean, default: false },
        isSelected: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("tr", {
                class: _normalizeClass({ clickable: _ctx.selectable, active: _ctx.isSelected })
            }, [
                _renderSlot(_ctx.$slots, "default")
            ], 2 /* CLASS */));
        };
    }
});
